module.exports = __webpack_public_path__ + "img/8153f1d.jpg";